export default "__VITE_ASSET__Vd6Lvg2G__"